<footer>
  <div class="end-contact">
    <div class="footer-logo">
      <img src="/images/logo.svg" />
    </div>
    <div class="address">VIA TARAMELLI, 8/10<br />26900 Lodi, Italia</div>
    <div class="contact-info">
      <a href="tel:0371 977 626">0371 977 626</a><br /><a
        href="mailto:info.chiese@cometralci.com"
        >INFO.CHIESE&#64;COMETRALCI.COM</a
      >
    </div>
    <div class="copyright">
      <span>© 2026 COMETRALCI<br />Diritti riservati</span>
    </div>
  </div>
</footer>
